export default class PlayerStatsModel {
  public playerId: string = null;
  public position: string = null;
  public minutesPlayed: number = null;
  public yellowCards: number = null;
  public redCards: number = null;
  public goals: number = null;
  public penaltyGoals: number = null;
  public penaltyCommitted: number = null;
  public penaltyWon: number = null;
  public penaltyMissed: number = null;
  public penaltySaved: number = null;
  public penaltyReceived: number = null;
  public ownGoals: number = null;
  public assists: number = null;
  public cleanSheets: number = null;
  public shots: number = null;
  public shotsOn: number = null;
  public shotsBlocked: number = null;
  public offsides: number = null;
  public foulsCommitted: number = null;
  public foulsWon: number = null;
  public tackles: number = null;
  public tacklesBlocks: number = null;
  public tacklesInterceptions: number = null;
  public concededGoals: number = null;
  public caughtBall: number = null;
  public saves: number = null;
  public passes: number = null;
  public crosses: number = null;
  public interceptions: number = null;
  public keyPasses: number = null;
  public passesAccuracy: number = null;
  public duels: number = null;
  public duelsWon: number = null;
  public dribblesAttempts: number = null;
  public dribblesSuccess: number = null;
  public dribblesPast: number = null;
  public updatedAt: string = null;
}
